var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntroBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1024,
    viewBox: "0 0 1440 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_400_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "url(#paint0_linear_400_2)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 168,
    width: 124,
    height: 512,
    rx: 20,
    fill: "#281F1F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 113,
    width: 79,
    height: 190,
    rx: 20,
    fill: "#281F1F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 822,
    y: 360,
    width: 170,
    height: 377,
    fill: "url(#paint1_linear_400_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1089 255H1302L1269 737H1114L1089 255Z",
    fill: "url(#paint2_linear_400_2)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M400.866 310.843C389.427 325.468 383 345.305 383 365.989V702H505L505 365.989C505 345.305 498.573 325.468 487.134 310.843C475.694 296.217 460.178 288 444 288C427.822 288 412.306 296.217 400.866 310.843Z",
    fill: "url(#paint3_linear_400_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.197 246.131C99.5471 234.659 108.675 225 120.165 225H273.835C285.325 225 294.453 234.659 293.803 246.131L267.069 718.131C266.469 728.72 257.707 737 247.101 737H146.899C136.293 737 127.531 728.72 126.931 718.131L100.197 246.131Z",
    fill: "url(#paint4_linear_400_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-37.7778 808.083C-0.777832 597.582 1353.22 583.082 1454.22 781.083C1516.22 886.583 1454.22 1127.08 1454.22 1127.08H-37.7778C-37.7778 1127.08 -110.278 872.582 -37.7778 808.083Z",
    fill: "#281F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915 69.1478C928.62 67.7825 942.169 71.3276 952.667 79.0032C963.164 86.6787 969.749 97.856 970.974 110.076C972.199 122.296 967.963 134.558 959.198 144.164C950.433 153.771 937.857 159.935 924.237 161.3L925.914 161.107C930.348 160.662 941.728 144.761 945.012 129.161C947.072 113.441 946.425 116.657 945.824 110.658C945.425 106.68 941.62 95.3239 938.667 90.0449C935.33 83.3501 921.116 68.5596 916.682 69.0041L915 69.1478Z",
    fill: "#EEC382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.654 201.546C572.565 198.81 576.435 198.81 577.346 201.546L578.419 204.768C578.827 205.993 579.974 206.82 581.265 206.82H584.577C587.501 206.82 588.697 210.576 586.311 212.267L583.761 214.075C582.684 214.839 582.232 216.217 582.65 217.47L583.654 220.485C584.57 223.236 581.438 225.557 579.073 223.88L576.235 221.869C575.196 221.132 573.804 221.132 572.765 221.869L569.927 223.88C567.562 225.557 564.43 223.236 565.346 220.485L566.35 217.47C566.768 216.217 566.316 214.839 565.239 214.075L562.689 212.267C560.303 210.576 561.499 206.82 564.423 206.82H567.735C569.026 206.82 570.173 205.993 570.581 204.768L571.654 201.546Z",
    fill: "#EEC382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1207.99 97.1437C1208.69 94.5943 1212.31 94.5943 1213.01 97.1437C1213.32 98.2729 1214.34 99.0557 1215.51 99.0557H1215.7C1218.33 99.0557 1219.54 102.327 1217.55 104.044L1216.81 104.679C1215.95 105.418 1215.59 106.584 1215.89 107.676L1216.24 108.947C1216.9 111.356 1214.04 113.163 1212.15 111.533C1211.2 110.716 1209.8 110.716 1208.85 111.533C1206.96 113.163 1204.1 111.356 1204.76 108.947L1205.11 107.676C1205.41 106.584 1205.05 105.418 1204.19 104.679L1203.45 104.044C1201.46 102.327 1202.67 99.0557 1205.3 99.0557H1205.49C1206.66 99.0557 1207.68 98.2729 1207.99 97.1437Z",
    fill: "#EEC382"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1004,
    cy: 80,
    r: 2,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1145,
    cy: 122,
    r: 2,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1041,
    cy: 290,
    r: 2,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 822,
    cy: 82,
    r: 2,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 924,
    cy: 231,
    r: 2,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1277,
    cy: 84,
    r: 2,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 708,
    cy: 253,
    r: 2,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156,
    cy: 62,
    r: 2,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 181,
    r: 2,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317,
    cy: 203,
    r: 2,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313,
    cy: 101,
    r: 2,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 533,
    cy: 60,
    r: 2,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 708,
    cy: 253,
    r: 2,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445 186L453 324H435L445 186Z",
    fill: "#281F1F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 800,
    y: 360,
    width: 214,
    height: 7,
    fill: "#281F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1086.5 171H1310.5L1360 291H1034L1086.5 171Z",
    fill: "#281F1F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 800,
    y: 463,
    width: 214,
    height: 7,
    fill: "#2B2A2D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 800,
    y: 552,
    width: 214,
    height: 7,
    fill: "#2E363C"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 50.5392,
    height: 15.4598,
    rx: 4,
    transform: "matrix(0.997016 -0.0771999 0.115924 0.993258 201.242 870.645)",
    fill: "#060606"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 46.6582,
    height: 17.0824,
    rx: 4,
    transform: "matrix(0.807112 -0.590399 0.740721 0.671813 332.688 874.327)",
    fill: "#060606"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M259.126 763.335C257.165 762.317 254.472 762.903 253.111 764.643L222.643 803.595C222.073 804.323 221.827 805.139 221.878 805.916C221.083 806.672 220.607 807.755 220.658 808.946L222.36 848.825C222.454 851.032 224.32 852.771 226.529 852.708L239.309 852.346C241.517 852.284 243.231 850.444 243.137 848.237L241.682 814.153C241.833 814.01 241.973 813.856 242.101 813.692L272.569 774.741C273.93 773.001 273.444 770.765 271.483 769.748L259.126 763.335Z",
    fill: "#060606"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M296.558 765.96C294.364 766.219 292.9 768.192 293.287 770.367L301.419 816.024C301.544 816.728 301.847 817.366 302.275 817.899C302.423 818.472 302.743 819.029 303.239 819.515L338.084 853.686C339.661 855.233 342.423 855.484 344.253 854.246L354.635 847.222C356.464 845.984 356.669 843.727 355.092 842.18L322.666 810.381L315.081 767.792C314.694 765.617 312.601 764.064 310.408 764.323L296.558 765.96Z",
    fill: "#060606"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 42.4394,
    height: 15.4598,
    rx: 4,
    transform: "matrix(0.997016 -0.0771999 0.115924 0.993258 212.382 850.057)",
    fill: "#91B7CE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 40.5616,
    height: 17.035,
    rx: 4,
    transform: "matrix(0.814664 -0.579933 0.73155 0.681788 326.005 853.065)",
    fill: "#91B7CE"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 284.788,
    cy: 753.779,
    rx: 41.2163,
    ry: 30.3958,
    fill: "#060606"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.207 732.91C317.093 712.495 317.65 678.469 269.193 660.776C251.37 658.054 236.61 661.684 227.42 666.674C218.23 671.664 209.597 686.635 213.495 697.07C231.319 702.968 253.041 723.836 254.712 738.354C264.737 741.076 306.51 739.261 318.207 732.91Z",
    fill: "#6F5F5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.164 756.804C210.526 766.415 225.447 767.914 233.656 762.234C245.121 754.303 266.39 738.413 280.635 716.193C287.472 705.527 292.284 675.957 287.355 668.119C284.623 661.748 277.053 657.291 264.477 660.011C263.961 705.706 222.072 747.094 212.164 756.804Z",
    fill: "#907E78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.8 739.28C182.96 703.503 199.137 690.157 199.137 690.157C205.721 689.021 213.878 690.492 222.16 695.703C204.11 709.64 203.145 741.527 197.863 745.221C192.58 748.915 180.523 743.953 177.8 739.28Z",
    fill: "#6F5F5A"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 10.2766,
    ry: 10.5596,
    transform: "matrix(0.983827 0.179121 -0.264641 0.964347 180.592 755.289)",
    fill: "#7B9B94"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 9.15202,
    ry: 12.038,
    transform: "matrix(0.667327 0.744765 -0.859586 0.510992 205.443 773.552)",
    fill: "#7B9B94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.344 633.102C234.104 622.668 235.775 626.038 230.205 618.585C222.407 608.151 214.61 597.716 192.33 600.438C170.608 602.707 170.608 621.307 170.051 625.39C170.051 635.358 170.051 640.815 171.165 647.166C167.823 654.879 167.823 658.572 167.823 665.313C167.823 684.856 190.017 700.699 217.394 700.699C244.772 700.699 266.965 684.856 266.965 665.313C266.965 651.192 250.256 637.639 241.344 633.102Z",
    fill: "#7B9B94"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 10.2047,
    ry: 10.6656,
    transform: "matrix(0.969328 -0.24577 0.356986 0.93411 247.531 628.751)",
    fill: "#7B9B94"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 10.2862,
    ry: 10.5453,
    transform: "matrix(0.985725 -0.168364 0.249317 0.968422 162.768 644.594)",
    fill: "#7B9B94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.568 639.754C194.745 640.449 194.736 641.168 194.542 641.871C194.347 642.573 193.971 643.245 193.434 643.849C192.897 644.452 192.211 644.975 191.414 645.387C190.617 645.799 189.725 646.093 188.789 646.251C187.853 646.409 186.891 646.429 185.958 646.309C185.025 646.19 184.14 645.933 183.353 645.554C182.566 645.174 181.892 644.68 181.37 644.098C180.848 643.517 180.489 642.86 180.312 642.165L187.44 640.96L194.568 639.754Z",
    fill: "#D4F7EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.835 632.697C227.082 633.361 227.155 634.061 227.051 634.757C226.947 635.453 226.667 636.131 226.227 636.752C225.788 637.373 225.197 637.926 224.49 638.378C223.782 638.83 222.97 639.173 222.102 639.387C221.234 639.601 220.325 639.682 219.428 639.625C218.532 639.569 217.664 639.376 216.875 639.057C216.087 638.739 215.392 638.301 214.832 637.769C214.272 637.237 213.856 636.621 213.609 635.957L220.222 634.327L226.835 632.697Z",
    fill: "#D4F7EF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.74412,
    ry: 1.66187,
    transform: "matrix(-0.218327 0.975876 -0.989163 -0.14682 202.355 652.156)",
    fill: "#516460"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.44992,
    ry: 1.94831,
    transform: "matrix(0.833281 0.55285 -0.707116 0.707098 213.495 649.436)",
    fill: "#516460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.372 672.353C210.411 675.424 207.266 679.456 204.027 681.646C200.128 683.461 197.343 683.914 193.529 680.569C188.272 668.521 200.057 660.142 208.483 657.601C216.908 655.061 234.292 653.42 243.416 661.394C245.152 663.481 245.946 664.263 246.824 667.357C247.041 676.401 228.243 669.075 217.372 672.353Z",
    fill: "#516460"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.84959,
    ry: 1.79531,
    transform: "matrix(-0.947987 -0.31831 0.451567 -0.892237 207.93 605.534)",
    fill: "#6D8983"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.69182,
    ry: 1.38203,
    transform: "matrix(-0.947987 -0.31831 0.451567 -0.892237 214.609 609.015)",
    fill: "#6D8983"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.07574,
    ry: 3.22457,
    transform: "matrix(-0.836095 -0.548584 0.703174 -0.711018 185.819 685.689)",
    fill: "#6C8983"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.98967,
    ry: 1.95746,
    transform: "matrix(-0.996511 -0.0834627 0.125248 -0.992125 193.444 690.679)",
    fill: "#6C8983"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.89651,
    height: 8.18688,
    rx: 2,
    transform: "matrix(0.996642 0.0818801 -0.122894 0.99242 223.413 655.331)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.85196,
    height: 7.56821,
    rx: 2,
    transform: "matrix(0.784319 -0.620358 0.76616 0.64265 198.934 676.812)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24.0965,
    height: 8.31233,
    rx: 4,
    transform: "matrix(0.996192 -0.0871858 0.102711 0.994711 875.411 672.731)",
    fill: "#060606"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.2781,
    height: 8.63262,
    rx: 4,
    transform: "matrix(0.770693 -0.637207 0.698277 0.715828 938.032 674.715)",
    fill: "#060606"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M904.746 615.981C902.84 614.863 900.277 615.429 899.019 617.246L886.709 635.035C886.038 636.004 885.875 637.134 886.158 638.147C885.245 638.908 884.682 640.07 884.731 641.354L885.402 659.137C885.486 661.344 887.343 663.077 889.551 663.006L891.453 662.945C893.661 662.875 895.383 661.028 895.3 658.82L894.654 641.697C895.169 641.394 895.626 640.982 895.979 640.472L908.289 622.683C909.546 620.867 909.021 618.488 907.115 617.37L904.746 615.981Z",
    fill: "#060606"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M922.892 616.087C920.702 616.379 919.206 618.386 919.55 620.568L922.847 641.491C923.011 642.536 923.568 643.432 924.345 644.05C924.312 644.965 924.631 645.899 925.321 646.663L939.283 662.139C940.763 663.78 943.385 664.022 945.14 662.68L946.888 661.343C948.643 660.001 948.866 657.584 947.386 655.944L933.424 640.468C933.369 640.407 933.312 640.348 933.254 640.291C933.247 640.229 933.239 640.167 933.229 640.104L929.932 619.181C929.589 616.999 927.535 615.467 925.345 615.759L922.892 616.087Z",
    fill: "#060606"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.2346,
    height: 8.31233,
    rx: 4,
    transform: "matrix(0.996192 -0.0871858 0.102711 0.994711 880.718 661.646)",
    fill: "#91B7CE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.2051,
    height: 8.62298,
    rx: 4,
    transform: "matrix(0.779112 -0.626885 0.688485 0.72525 934.848 663.267)",
    fill: "#91B7CE"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 915.212,
    cy: 609.804,
    rx: 19.6352,
    ry: 16.367,
    fill: "#060606"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.133 598.566C930.602 587.574 930.868 569.252 907.783 559.725C899.292 558.26 892.261 560.214 887.883 562.901C883.504 565.588 879.392 573.649 881.249 579.268C889.74 582.444 900.088 593.681 900.884 601.498C905.66 602.963 925.561 601.986 931.133 598.566Z",
    fill: "#556245"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.615 611.433C879.834 616.608 886.942 617.415 890.853 614.357C896.315 610.086 906.448 601.53 913.234 589.565C916.491 583.822 918.783 567.9 916.435 563.679C915.134 560.249 911.527 557.849 905.536 559.314C905.29 583.918 885.335 606.204 880.615 611.433Z",
    fill: "#6F805A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.244 601.997C866.702 582.732 874.409 575.546 874.409 575.546C877.545 574.934 881.431 575.726 885.377 578.532C876.778 586.037 876.318 603.207 873.802 605.196C871.285 607.185 865.541 604.513 864.244 601.997Z",
    fill: "#556245"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.91747,
    ry: 5.64251,
    transform: "matrix(0.979476 0.201563 -0.235938 0.971768 865.574 610.617)",
    fill: "#7B9B94"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.68357,
    ry: 5.939,
    transform: "matrix(0.621221 0.783636 -0.830035 0.557711 877.413 620.451)",
    fill: "#7B9B94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.516 544.824C891.067 539.206 891.863 541.02 889.209 537.007C885.494 531.389 881.78 525.77 871.166 527.236C860.818 528.457 860.818 538.473 860.552 540.672C860.552 546.039 860.552 548.977 861.083 552.397C859.491 556.55 859.491 558.539 859.491 562.169C859.491 572.692 870.064 581.223 883.106 581.223C896.149 581.223 906.722 572.692 906.722 562.169C906.722 554.565 898.762 547.267 894.516 544.824Z",
    fill: "#7B9B94"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.90206,
    ry: 5.66297,
    transform: "matrix(0.961304 -0.275491 0.320303 0.947315 897.463 542.482)",
    fill: "#7B9B94"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.91953,
    ry: 5.63976,
    transform: "matrix(0.98187 -0.189555 0.222083 0.975028 857.083 551.012)",
    fill: "#7B9B94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.232 548.405C872.316 548.78 872.312 549.167 872.219 549.545C872.127 549.923 871.947 550.285 871.692 550.61C871.436 550.935 871.109 551.216 870.729 551.438C870.35 551.66 869.925 551.818 869.479 551.904C869.033 551.989 868.574 552 868.13 551.935C867.686 551.871 867.264 551.732 866.889 551.528C866.514 551.324 866.193 551.058 865.945 550.744C865.696 550.431 865.525 550.078 865.44 549.704L868.836 549.054L872.232 548.405Z",
    fill: "#D4F7EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M887.604 544.606C887.721 544.964 887.756 545.341 887.707 545.716C887.657 546.09 887.524 546.455 887.314 546.79C887.105 547.124 886.824 547.422 886.486 547.665C886.149 547.908 885.763 548.093 885.349 548.208C884.935 548.324 884.502 548.367 884.075 548.337C883.648 548.306 883.235 548.202 882.859 548.031C882.483 547.859 882.152 547.624 881.885 547.337C881.619 547.051 881.421 546.719 881.303 546.361L884.453 545.484L887.604 544.606Z",
    fill: "#D4F7EF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.46993,
    ry: 0.79407,
    transform: "matrix(-0.194169 0.980968 -0.986217 -0.165455 875.942 555.083)",
    fill: "#516460"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.208,
    ry: 0.990471,
    transform: "matrix(0.800038 0.599949 -0.662632 0.748945 881.249 553.619)",
    fill: "#516460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883.096 565.959C879.779 567.613 878.281 569.784 876.738 570.963C874.881 571.94 873.554 572.185 871.737 570.383C869.233 563.896 874.847 559.384 878.861 558.016C882.875 556.648 891.156 555.765 895.503 560.058C896.33 561.182 896.708 561.603 897.126 563.269C897.23 568.139 888.274 564.194 883.096 565.959Z",
    fill: "#516460"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.85953,
    ry: 0.945049,
    transform: "matrix(-0.934932 -0.354826 0.408671 -0.912682 878.598 529.98)",
    fill: "#6D8983"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 0.817226,
    ry: 0.727502,
    transform: "matrix(-0.934932 -0.354826 0.408671 -0.912682 881.78 531.855)",
    fill: "#6D8983"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.51702,
    ry: 1.6404,
    transform: "matrix(-0.803223 -0.595678 0.658493 -0.752587 868.064 573.14)",
    fill: "#6C8983"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 0.948785,
    ry: 1.05222,
    transform: "matrix(-0.995549 -0.0942455 0.111001 -0.99382 871.697 575.828)",
    fill: "#6C8983"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.24219,
    height: 4.40108,
    rx: 2,
    transform: "matrix(0.995716 0.0924618 -0.108907 0.994052 885.974 556.794)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.43415,
    height: 3.80649,
    rx: 1.71707,
    transform: "matrix(0.745514 -0.66649 0.725697 0.688015 874.312 568.36)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1133.38 676.504C1131.3 675.548 1128.62 676.181 1127.4 677.917L1089.58 731.705C1088.89 732.69 1088.82 733.819 1089.26 734.785C1089.02 735.524 1089.01 736.359 1089.3 737.188L1104.1 779.578C1104.83 781.671 1107.15 782.934 1109.29 782.399L1116.97 780.48C1119.11 779.945 1120.25 777.815 1119.52 775.723L1106.11 737.3L1142.87 685.016C1144.09 683.28 1143.39 681.098 1141.31 680.142L1133.38 676.504Z",
    fill: "#060606"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1161.35 669.399C1159.17 669.07 1157.06 670.564 1156.65 672.735L1143.96 739.281C1143.78 740.224 1143.95 741.139 1144.38 741.9C1144.38 742.666 1144.68 743.44 1145.3 744.095L1175.14 775.412C1176.63 776.975 1179.39 777.272 1181.31 776.076L1190.22 770.511C1192.14 769.315 1192.48 767.078 1190.99 765.515L1163.26 736.412L1174.88 675.484C1175.29 673.312 1173.86 671.285 1171.68 670.956L1161.35 669.399Z",
    fill: "#060606"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1184.24 670.726C1182.15 680.123 1149.74 687.629 1124.9 688C1100.07 688.371 1091.35 676.585 1108.83 672.189C1101.34 676.149 1094.57 671.134 1096.58 665.449C1098.58 659.764 1109.69 646.429 1145.64 649.385C1181.59 652.342 1186.1 662.404 1184.24 670.726Z",
    fill: "#060606"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.17 685.552C1041.4 647.664 1079.79 622.222 1090.1 622.222C1100.42 622.222 1117.42 630.493 1109.22 634.112C1047.31 654.016 1050.04 679.607 1048.22 686.069C1046.4 692.531 1037.3 689.171 1035.17 685.552Z",
    fill: "#9B8A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1171.78 653.917C1170.83 636.826 1171.31 608.342 1130.27 593.53C1115.17 591.251 1102.67 594.289 1094.89 598.467C1087.11 602.645 1073.9 615.178 1077.2 623.913C1092.3 628.851 1110.69 646.321 1112.11 658.475C1120.6 660.753 1161.87 659.234 1171.78 653.917Z",
    fill: "#9B8A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1077.33 691.239C1071.58 702.767 1062.26 696.574 1064.31 689.688C1067.16 680.07 1070.96 674.954 1077.33 667.716C1083.48 660.737 1118.03 633.224 1125 631.543C1130.35 629.563 1150.5 643.418 1127.43 651.689C1104.37 659.961 1083.09 679.711 1077.33 691.239Z",
    fill: "#B5A9B4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 6.9968,
    ry: 7.15454,
    transform: "matrix(0.983997 0.178183 -0.265979 0.963979 1040.12 698.273)",
    fill: "#5B5A74"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.15575,
    ry: 6.79235,
    transform: "matrix(0.669334 0.742962 -0.8608 0.508944 1065.58 706.885)",
    fill: "#5B5A74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1059.31 563.306C1060.56 561.526 1061.35 561.025 1062.97 561.477C1065.7 565.792 1067.43 567.988 1070.93 571.618L1066.65 573.741L1059.31 563.306Z",
    fill: "#5B5A74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1072.66 559.168C1073.92 557.389 1074.7 556.888 1076.32 557.339C1079.05 561.654 1080.78 563.851 1084.28 567.481L1080.01 569.603L1072.66 559.168Z",
    fill: "#5B5A74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1084.8 555.55C1086.06 553.77 1086.84 553.27 1088.46 553.721C1091.19 558.036 1092.92 560.232 1096.42 563.862L1092.15 565.985L1084.8 555.55Z",
    fill: "#5B5A74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1061.71 558.25C1061.71 559.493 1060.53 561.25 1059.07 561.25C1057.61 561.25 1056.43 560.243 1056.43 559C1056.43 557.757 1057.61 556 1059.07 556C1060.53 556 1061.71 557.007 1061.71 558.25Z",
    fill: "#5B5A74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074.04 553.75C1074.04 554.993 1072.86 556.75 1071.4 556.75C1069.94 556.75 1068.76 555.743 1068.76 554.5C1068.76 553.257 1069.94 551.5 1071.4 551.5C1072.86 551.5 1074.04 552.507 1074.04 553.75Z",
    fill: "#5B5A74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1088.13 549.25C1088.13 550.493 1086.95 552.25 1085.49 552.25C1084.03 552.25 1082.84 551.243 1082.84 550C1082.84 548.757 1084.03 547 1085.49 547C1086.95 547 1088.13 548.007 1088.13 549.25Z",
    fill: "#5B5A74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.91 570.356C1168.63 596.803 1133.27 607.489 1109.88 618.441C1092.91 626.388 1067.84 647.56 1041.59 621.113C1017.72 597.07 1059.05 574.715 1083.37 564.479C1101.15 556.999 1141.64 551.389 1152.91 570.356Z",
    fill: "#5B5A74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1039.38 613.986C1042.14 618.554 1045.2 622.836 1039.84 625.191C1034.47 627.545 1028.63 627.231 1025.87 622.663C1023.11 618.094 1024.46 611.002 1029.83 608.648C1035.19 606.293 1036.61 609.418 1039.38 613.986Z",
    fill: "#5B5A74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.95 569.889C1142.72 565.549 1139.22 561.517 1144.32 558.764C1149.41 556.011 1155.26 555.881 1158.5 560.221C1161.73 564.561 1161.12 571.727 1156.02 574.48C1150.93 577.233 1149.18 574.229 1145.95 569.889Z",
    fill: "#5B5A74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1130.39 795.639C1130.39 800.137 1122.48 804.038 1105.51 804.038C1088.55 804.038 1077.56 807.008 1077.56 802.511C1077.56 798.013 1088.55 787.75 1105.51 787.75C1122.48 787.75 1130.39 791.142 1130.39 795.639Z",
    fill: "#A2614D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1206.32 778.714C1208.09 782.325 1205.02 787.084 1191.77 791.792C1178.52 796.5 1171.11 801.935 1169.34 798.324C1167.57 794.712 1172.11 783.422 1185.36 778.714C1198.61 774.006 1204.55 775.103 1206.32 778.714Z",
    fill: "#A2614D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1107 582.885L1116.04 576.05C1116.04 576.05 1121.72 582.129 1118.93 584.516C1116.15 586.904 1107 582.885 1107 582.885Z",
    fill: "#B1A1A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048 610.203L1059.45 606.896C1059.45 606.896 1061.92 614.378 1058.26 615.656C1054.6 616.933 1048 610.203 1048 610.203Z",
    fill: "#B1A1A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.91 601.7C1128.44 603.429 1114.97 608.985 1110.33 610.355C1105.69 611.726 1104.05 608.727 1103.48 607.345C1102.92 605.962 1103.39 604.799 1108.02 603.429C1112.66 602.058 1120.49 599.539 1124.91 601.7Z",
    fill: "#424254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1097.34 602.137C1097.34 603.654 1096.47 604.397 1095.52 604.802C1094.56 605.207 1093.2 604.146 1093.2 602.998C1093.2 601.596 1094.39 600.046 1095.52 600.046C1096.64 600.046 1097.34 601.03 1097.34 602.137Z",
    fill: "#424254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1128.48 565.11C1124.93 565.159 1123.44 566.601 1122.49 564.653C1121.54 562.706 1124.63 561.579 1127.32 561.541C1130.6 561.496 1133.62 562.184 1133.63 564.499C1133.63 566.815 1131.07 565.074 1128.48 565.11Z",
    fill: "#424254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090.05 605.056C1091.62 605.771 1091.98 606.777 1091.94 607.685C1091.91 608.593 1090.18 609.111 1088.99 608.57C1087.54 607.909 1086.49 606.29 1087.02 605.443C1087.55 604.596 1088.9 604.534 1090.05 605.056Z",
    fill: "#424254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1139.17 564.751C1140.9 565.383 1141.24 566.252 1141.16 567.032C1141.07 567.813 1139.08 568.241 1137.78 567.763C1136.18 567.179 1135.1 565.776 1135.74 565.053C1136.39 564.33 1137.91 564.291 1139.17 564.751Z",
    fill: "#424254"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M462.88 627.342C461.141 626.18 458.912 626.932 457.902 629.02L443.55 658.714C443.019 659.811 442.931 661.059 443.219 662.165C442.742 663.007 442.561 664.014 442.791 664.972L448.605 689.206C449.052 691.071 450.887 692.048 452.702 691.388C454.518 690.728 455.627 688.68 455.18 686.815L449.678 663.881C449.852 663.651 450.009 663.395 450.144 663.116L464.497 633.422C465.507 631.334 464.914 628.7 463.175 627.538L462.88 627.342Z",
    fill: "#060606"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M475.461 622.389C473.315 621.918 471.344 623.297 471.059 625.469L466.043 663.75C465.904 664.809 466.191 665.86 466.771 666.715C466.659 667.812 466.902 668.968 467.527 669.922L478.031 685.958C479.278 687.862 481.574 688.239 483.158 686.799L484.177 685.874C485.762 684.435 486.036 681.725 484.789 679.821L474.285 663.784C474.217 663.681 474.146 663.582 474.072 663.487L478.831 627.174C479.116 625.002 477.607 622.86 475.461 622.389Z",
    fill: "#060606"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.02 622.73C482.127 628.558 468.31 633.212 457.722 633.442C447.133 633.672 443.416 626.363 450.87 623.637C447.675 626.093 444.79 622.983 445.646 619.457C446.501 615.932 451.238 607.662 466.562 609.495C481.887 611.329 483.81 617.569 483.02 622.73Z",
    fill: "#060606"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.469 631.923C422.123 608.427 438.487 592.649 442.886 592.649C447.285 592.649 454.53 597.778 451.037 600.023C424.644 612.366 425.808 628.236 425.032 632.244C424.256 636.252 420.374 634.168 419.469 631.923Z",
    fill: "#9B8A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.706 612.305C477.303 601.706 477.504 584.041 460.009 574.856C453.574 573.443 448.245 575.327 444.927 577.918C441.609 580.508 435.978 588.281 437.386 593.698C443.821 596.76 451.664 607.594 452.267 615.131C455.887 616.545 473.482 615.603 477.706 612.305Z",
    fill: "#9B8A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.442 635.451C434.987 642.6 431.018 638.76 431.889 634.489C433.107 628.524 434.725 625.351 437.442 620.863C440.062 616.535 454.792 599.472 457.765 598.43C460.043 597.202 468.633 605.794 458.8 610.924C448.967 616.054 439.897 628.302 437.442 635.451Z",
    fill: "#B5A9B4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.03524,
    ry: 4.35335,
    transform: "matrix(0.967013 0.254726 -0.186353 0.982483 421.578 639.813)",
    fill: "#6B664C"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.79419,
    ry: 3.28772,
    transform: "matrix(0.526516 0.850165 -0.758157 0.652072 432.432 645.153)",
    fill: "#6B664C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.758 556.112C430.293 555.009 430.628 554.698 431.319 554.978C432.482 557.654 433.219 559.016 434.71 561.267L432.889 562.583L429.758 556.112Z",
    fill: "#6B664C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.451 553.546C435.985 552.442 436.32 552.132 437.012 552.412C438.175 555.088 438.912 556.45 440.403 558.701L438.582 560.017L435.451 553.546Z",
    fill: "#6B664C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.626 551.303C441.161 550.199 441.495 549.889 442.187 550.169C443.35 552.844 444.087 554.207 445.578 556.458L443.757 557.774L440.626 551.303Z",
    fill: "#6B664C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.783 552.976C430.783 553.747 430.278 554.837 429.656 554.837C429.034 554.837 428.53 554.212 428.53 553.442C428.53 552.671 429.034 551.581 429.656 551.581C430.278 551.581 430.783 552.206 430.783 552.976Z",
    fill: "#5B5A74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.038 550.186C436.038 550.957 435.534 552.047 434.912 552.047C434.29 552.047 433.785 551.422 433.785 550.651C433.785 549.881 434.29 548.791 434.912 548.791C435.534 548.791 436.038 549.416 436.038 550.186Z",
    fill: "#5B5A74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.044 547.395C442.044 548.166 441.54 549.256 440.918 549.256C440.296 549.256 439.792 548.631 439.792 547.86C439.792 547.09 440.296 546 440.918 546C441.54 546 442.044 546.625 442.044 547.395Z",
    fill: "#5B5A74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.662 560.485C476.363 576.886 461.287 583.512 451.317 590.305C444.083 595.233 433.396 608.363 422.203 591.961C412.028 577.051 429.648 563.188 440.017 556.84C447.595 552.201 464.857 548.722 469.662 560.485Z",
    fill: "#6B664C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.261 587.541C422.439 590.374 423.744 593.03 421.457 594.49C419.171 595.95 416.681 595.755 415.503 592.922C414.324 590.089 414.903 585.691 417.189 584.231C419.476 582.771 420.082 584.708 421.261 587.541Z",
    fill: "#6B664C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.695 560.195C465.318 557.503 463.827 555.003 465.999 553.295C468.172 551.588 470.665 551.507 472.043 554.199C473.421 556.89 473.161 561.335 470.989 563.042C468.817 564.749 468.073 562.886 466.695 560.195Z",
    fill: "#6B664C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.063 700.194C460.063 702.984 456.688 705.403 449.456 705.403C442.224 705.403 437.54 707.245 437.54 704.456C437.54 701.666 442.224 695.302 449.456 695.302C456.688 695.302 460.063 697.405 460.063 700.194Z",
    fill: "#A2614D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.432 689.699C493.187 691.938 491.877 694.889 486.228 697.809C480.58 700.729 477.419 704.099 476.665 701.86C475.911 699.62 477.849 692.619 483.497 689.699C489.146 686.779 491.678 687.459 492.432 689.699Z",
    fill: "#A2614D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.089 568.254L453.943 564.015C453.943 564.015 456.366 567.785 455.177 569.265C453.989 570.746 450.089 568.254 450.089 568.254Z",
    fill: "#B1A1A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.938 585.195L429.819 583.145C429.819 583.145 430.87 587.784 429.31 588.577C427.75 589.369 424.938 585.195 424.938 585.195Z",
    fill: "#B1A1A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.725 579.923C459.232 580.995 453.487 584.44 451.51 585.29C449.533 586.14 448.83 584.281 448.59 583.423C448.35 582.566 448.549 581.845 450.526 580.995C452.503 580.145 455.842 578.583 457.725 579.923Z",
    fill: "#2D2D41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.972 580.194C445.972 581.134 445.6 581.595 445.193 581.846C444.786 582.097 444.208 581.44 444.208 580.728C444.208 579.858 444.713 578.897 445.193 578.897C445.674 578.897 445.972 579.507 445.972 580.194Z",
    fill: "#2D2D41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.246 557.231C457.732 557.262 457.1 558.156 456.694 556.948C456.288 555.741 457.605 555.041 458.751 555.018C460.151 554.99 461.438 555.417 461.441 556.853C461.443 558.289 460.351 557.209 459.246 557.231Z",
    fill: "#9C9571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.862 582.004C443.532 582.447 443.684 583.071 443.671 583.634C443.658 584.197 442.917 584.519 442.41 584.183C441.791 583.773 441.345 582.769 441.572 582.244C441.798 581.719 442.373 581.68 442.862 582.004Z",
    fill: "#2D2D41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.804 557.009C464.54 557.4 464.687 557.939 464.65 558.423C464.614 558.907 463.768 559.172 463.211 558.876C462.53 558.514 462.068 557.644 462.344 557.196C462.619 556.747 463.267 556.723 463.804 557.009Z",
    fill: "#9C9571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.776 747.074C805.776 744.978 792.851 722.69 784.878 717.206L746.825 733.45L760.861 770.917C760.861 770.917 723.119 795.021 721.248 801.833C719.376 808.645 724.991 851.089 724.991 851.089C731.147 855.701 728.42 857.403 735.596 854.705C735.596 854.705 734.348 818.287 735.596 813.309C736.843 808.331 760.494 788.364 779.263 777.205C779.263 777.205 792.987 816.243 799.849 824.103C806.712 831.963 830.729 857.377 833.848 858.95C836.967 860.522 841.646 853.185 841.646 851.089C841.645 848.993 828.233 833.011 821.995 826.461C815.757 819.911 810.766 814.409 808.895 805.239C807.023 796.069 798.914 753.886 799.849 752.052C800.785 750.218 805.776 749.17 805.776 747.074Z",
    fill: "#060606",
    stroke: "#060606"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798.914 716.422C797.951 699.103 790.804 677.121 751.816 661.663C740.275 657.088 727.833 659.443 719.885 663.676C711.936 667.909 701.657 682.156 705.029 691.007C720.444 696.01 754.731 719.801 756.177 732.116C764.847 734.425 788.798 721.809 798.914 716.422Z",
    fill: "#E1E2DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M752.128 726.641L746.236 724.403C742.601 737.623 735.748 764.414 735.227 766.727C734.706 769.04 735.109 769.961 738.034 768.561C740.959 767.161 752.128 726.641 752.128 726.641Z",
    fill: "#848473"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.347 693.365C767.493 691.696 762.733 689.697 762.733 689.697C762.733 689.697 752.501 711.136 751.816 713.015C751.13 714.895 753.159 715.394 755.74 714.458C758.321 713.522 768.347 693.365 768.347 693.365Z",
    fill: "#848473"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.963 735.603C743.213 738.282 749.364 731.304 752.751 728.997C757.483 725.776 758.9 727.69 761.485 720.089C762.733 716.421 768.105 707.295 760.861 705.736C755.908 704.341 755.096 711.833 747.137 713.801C743.706 726.901 742.729 732.071 739.963 735.603Z",
    fill: "#EAEBE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.49 730.783L700.704 730.368C699.26 741.593 702.425 756.807 702.088 758.743C701.75 760.679 698.789 759.681 697.056 757.883C695.322 756.085 694.49 730.783 694.49 730.783Z",
    fill: "#848473"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.7 632.048V694.413H729.12V682.211L708.661 676.859L698.431 624.591L688.981 616.074C683.77 620.526 680.7 626.466 680.7 632.048Z",
    fill: "#B2C954"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.578 730.916C703.844 733.177 692.745 733.424 690.66 730.939C689.519 729.581 687.449 712.465 691.746 697.941C695.306 685.902 704.988 676.048 707.426 674.766C712.804 671.936 717.275 674.568 722.699 677.978C706.852 683.768 707.312 728.656 705.578 730.916Z",
    fill: "#EAEBE2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.06022,
    ry: 4.15212,
    transform: "matrix(0.966488 -0.25671 0.329228 0.944251 700.008 768.429)",
    fill: "#848473"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.65464,
    ry: 6.04829,
    transform: "matrix(0.98959 0.143918 -0.25631 0.966595 735.426 777.471)",
    fill: "#848473"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.753 679.179C770.022 680.904 771.148 688.113 765.806 684.939C763.683 685.259 762.066 682.602 761.797 680.878C761.528 679.153 757.074 677.347 759.197 677.027C761.319 676.706 769.484 677.454 769.753 679.179Z",
    fill: "#848473"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.273 637.045C774.273 638.052 774.124 638.868 772.403 638.868C770.682 638.868 769.286 638.052 769.286 637.045C769.286 636.039 769.123 634.676 770.845 634.676C772.566 634.676 774.273 636.039 774.273 637.045Z",
    fill: "#848473"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.973 644.512C676.092 645.352 676.109 646.04 675.18 646.133C674.252 646.226 673.403 645.622 673.283 644.783C673.164 643.943 672.914 642.816 673.843 642.723C674.771 642.63 675.853 643.673 675.973 644.512Z",
    fill: "#848473"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.957 642.276C677.893 641.49 761.173 634.416 764.916 635.726C768.659 637.036 764.432 639.107 763.115 639.382C761.797 639.656 680.7 646.468 679.14 645.944C677.581 645.42 676.021 643.062 676.957 642.276Z",
    fill: "#848473"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.94071,
    height: 6.94704,
    rx: 1.97036,
    transform: "matrix(0.996769 0.0803221 -0.125256 0.992124 705.275 689.697)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.925 686.171C759.925 690.057 755.262 689.689 747.071 689.689C745.34 687.996 739.16 689.47 739.16 685.584C739.16 681.698 736.407 675.55 744.599 675.55C752.79 675.55 759.925 682.285 759.925 686.171Z",
    fill: "#848473"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M704.093 621.051C690.122 625.361 681.948 651.443 702.534 659.565C702.877 662.094 703.146 664.736 703.405 667.28C704.213 675.233 704.925 682.233 707.524 681.836C708.139 681.742 709.244 681.718 710.644 681.784C717.059 682.085 729.67 684.259 729.67 690.124C729.67 695.156 721.777 694.967 714.058 694.781C712.907 694.753 711.76 694.726 710.644 694.716C708.618 694.697 706.693 694.736 705.029 694.936C696.296 695.984 726.551 706.726 734.349 700.176C742.147 693.626 741.835 682.98 741.835 682.98C742.59 671.955 742.544 665.186 741.835 652.325C756.508 646.244 741.835 624.719 733.101 621.051C724.368 617.383 718.065 616.742 704.093 621.051Z",
    fill: "#848473"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.67 690.124C729.67 684.259 717.059 682.085 710.644 681.784C710.644 681.784 713.139 686.028 712.515 690.124C711.891 694.22 710.644 694.716 710.644 694.716C711.76 694.726 712.907 694.753 714.058 694.781C721.777 694.967 729.67 695.156 729.67 690.124Z",
    fill: "#A1A78A"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.32299,
    ry: 1.52908,
    transform: "matrix(-0.949814 -0.312815 0.458545 -0.888671 728.225 622.927)",
    fill: "#B8B896"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.46039,
    ry: 1.17709,
    transform: "matrix(-0.949814 -0.312815 0.458545 -0.888671 734.002 625.881)",
    fill: "#B8B896"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.72785,
    ry: 2.31365,
    transform: "matrix(-0.0656617 -0.997842 0.999327 -0.0366845 736.555 667.251)",
    fill: "#B8B896"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.24255,
    ry: 0.90461,
    transform: "matrix(-0.0656617 -0.997842 0.999327 -0.0366845 706.638 674.45)",
    fill: "#B8B896"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.28226,
    ry: 0.884587,
    transform: "matrix(-0.459522 -0.888167 0.942799 -0.333361 709.738 674.361)",
    fill: "#B8B896"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.07779,
    ry: 1.78105,
    transform: "matrix(-0.0656617 -0.997842 0.999327 -0.0366845 735.641 676.633)",
    fill: "#B8B896"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M719.151 691.193C718.69 690.232 717.501 689.736 716.494 690.085C715.487 690.435 715.044 691.498 715.504 692.46L716.637 694.828C718.27 694.852 719.185 694.809 720.816 694.675L719.151 691.193Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.091 643.323C738.091 649.256 732.368 654.065 725.308 654.065C718.248 654.065 715.01 649.256 715.01 643.323C715.01 637.39 718.248 632.581 725.308 632.581C732.368 632.581 738.091 637.39 738.091 643.323Z",
    fill: "#EAECE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.676 648.15C709.409 651.715 706.802 655.069 702.854 655.642C698.905 656.215 696.5 653.588 695.767 650.023C695.034 646.458 697.337 647.564 701.286 646.991C705.234 646.418 707.943 644.585 708.676 648.15Z",
    fill: "#EAECE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.072 875.193H693.176C703.797 869.078 721.934 865.246 730.917 864.189C739.9 863.133 744.849 865.062 748.072 875.193Z",
    fill: "#112E3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866 861.729L822.619 881.744C824.702 872.089 837.873 866.211 842.858 861.1C847.842 855.99 855.98 855.759 866 861.729Z",
    fill: "#112E3C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M698.431 624.591C707.237 638.875 717.517 641.053 742.078 638.149C741.738 650.81 741.552 657.892 742.078 666.641C742.976 682.422 740.881 686.046 738.091 694.413H761.173C761.173 694.413 757.081 640.86 748.897 628.659C740.714 616.457 725.028 609 708.661 609C700.716 609 693.896 611.875 688.981 616.074L698.431 624.591Z",
    fill: "#B2C954"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.54 614.956C625.54 613.924 619.647 602.955 616.012 600.256L598.661 608.251L605.061 626.69C605.061 626.69 587.852 638.554 586.999 641.906C586.146 645.259 588.706 666.149 588.706 666.149C591.513 668.418 590.269 669.256 593.541 667.928C593.541 667.928 592.972 650.005 593.541 647.555C594.11 645.105 604.893 635.278 613.452 629.785C613.452 629.785 619.709 648.999 622.838 652.867C625.967 656.736 636.918 669.244 638.34 670.017C639.762 670.791 641.895 667.18 641.895 666.149C641.895 665.117 635.78 657.251 632.936 654.028C630.091 650.804 627.816 648.096 626.962 643.583C626.109 639.07 622.411 618.309 622.838 617.406C623.265 616.503 625.54 615.988 625.54 614.956Z",
    fill: "#060606",
    stroke: "#060606"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.412 599.869C621.972 591.345 618.714 580.526 600.937 572.918C595.675 570.667 590.002 571.826 586.378 573.909C582.753 575.993 578.066 583.004 579.604 587.361C586.632 589.823 602.266 601.532 602.925 607.593C606.879 608.73 617.799 602.521 622.412 599.869Z",
    fill: "#E1E2DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.079 604.899L598.392 603.798C596.735 610.304 593.611 623.49 593.373 624.628C593.135 625.767 593.319 626.22 594.653 625.531C595.987 624.842 601.079 604.899 601.079 604.899Z",
    fill: "#848473"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.474 588.522C608.085 587.7 605.914 586.717 605.914 586.717C605.914 586.717 601.249 597.268 600.937 598.193C600.624 599.118 601.549 599.364 602.726 598.903C603.903 598.443 608.474 588.522 608.474 588.522Z",
    fill: "#848473"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.532 609.31C597.014 610.629 599.819 607.194 601.363 606.059C603.521 604.473 604.167 605.415 605.346 601.675C605.914 599.869 608.364 595.378 605.061 594.61C602.802 593.924 602.433 597.611 598.804 598.58C597.239 605.027 596.793 607.572 595.532 609.31Z",
    fill: "#EAEBE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.799 606.937L577.632 606.733C576.974 612.258 578.417 619.745 578.263 620.698C578.109 621.651 576.759 621.16 575.968 620.275C575.178 619.39 574.799 606.937 574.799 606.937Z",
    fill: "#848473"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.511 558.343V589.037H590.588V583.032L581.26 580.398L576.596 554.673L572.287 550.482C569.911 552.673 568.511 555.596 568.511 558.343Z",
    fill: "#8E452E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.854 607.004C579.064 608.116 574.003 608.238 573.052 607.015C572.532 606.346 571.588 597.923 573.547 590.774C575.171 584.849 579.585 579.999 580.697 579.368C583.149 577.976 585.188 579.271 587.661 580.949C580.435 583.799 580.645 605.891 579.854 607.004Z",
    fill: "#EAEBE2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.86134,
    ry: 2.02778,
    transform: "matrix(0.961272 -0.2756 0.307377 0.951588 577.315 625.465)",
    fill: "#848473"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.58269,
    ry: 2.96288,
    transform: "matrix(0.987902 0.155082 -0.238567 0.971126 593.464 629.916)",
    fill: "#848473"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.115 581.539C609.238 582.388 609.752 585.936 607.316 584.374C606.348 584.532 605.61 583.224 605.488 582.375C605.365 581.526 603.334 580.638 604.302 580.48C605.27 580.322 608.993 580.69 609.115 581.539Z",
    fill: "#848473"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.176 560.803C611.176 561.298 611.108 561.7 610.324 561.7C609.539 561.7 608.903 561.298 608.903 560.803C608.903 560.307 608.828 559.637 609.613 559.637C610.398 559.637 611.176 560.307 611.176 560.803Z",
    fill: "#848473"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.355 564.478C566.41 564.891 566.417 565.23 565.994 565.275C565.571 565.321 565.184 565.024 565.129 564.611C565.075 564.198 564.961 563.643 565.384 563.597C565.807 563.551 566.301 564.065 566.355 564.478Z",
    fill: "#848473"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.804 563.378C567.231 562.991 605.203 559.509 606.91 560.154C608.616 560.799 606.689 561.818 606.089 561.953C605.488 562.088 568.511 565.441 567.8 565.183C567.089 564.925 566.378 563.765 566.804 563.378Z",
    fill: "#848473"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.79776,
    height: 3.4153,
    rx: 0.89888,
    transform: "matrix(0.996238 0.0866544 -0.11617 0.993229 579.716 586.717)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.634 584.981C604.634 586.894 602.508 586.713 598.773 586.713C597.984 585.88 595.166 586.605 595.166 584.693C595.166 582.78 593.911 579.754 597.646 579.754C601.381 579.754 604.634 583.069 604.634 584.981Z",
    fill: "#848473"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M579.177 552.932C572.807 555.053 569.08 567.89 578.466 571.887C578.623 573.132 578.745 574.432 578.863 575.684C579.232 579.598 579.557 583.043 580.742 582.848C581.022 582.802 581.526 582.79 582.164 582.822C585.089 582.971 590.839 584.041 590.839 586.927C590.839 589.404 587.24 589.311 583.721 589.219C583.196 589.206 582.673 589.192 582.164 589.187C581.24 589.178 580.363 589.197 579.604 589.295C575.622 589.811 589.417 595.098 592.973 591.874C596.528 588.651 596.386 583.411 596.386 583.411C596.73 577.985 596.709 574.653 596.386 568.324C603.076 565.331 596.386 554.737 592.404 552.932C588.422 551.126 585.548 550.811 579.177 552.932Z",
    fill: "#848473"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.839 586.927C590.839 584.041 585.089 582.971 582.164 582.822C582.164 582.822 583.302 584.911 583.017 586.927C582.733 588.943 582.164 589.187 582.164 589.187C582.673 589.192 583.196 589.206 583.721 589.219C587.24 589.311 590.839 589.404 590.839 586.927Z",
    fill: "#A1A78A"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.52734,
    ry: 0.741264,
    transform: "matrix(-0.942232 -0.334961 0.431285 -0.902216 590.18 553.854)",
    fill: "#B8B896"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 0.671234,
    ry: 0.570628,
    transform: "matrix(-0.942232 -0.334961 0.431285 -0.902216 592.814 555.308)",
    fill: "#B8B896"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.32618,
    ry: 1.05505,
    transform: "matrix(-0.0608497 -0.998147 0.999216 -0.0395933 593.979 575.669)",
    fill: "#B8B896"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 0.611356,
    ry: 0.412511,
    transform: "matrix(-0.0608497 -0.998147 0.999216 -0.0395933 580.338 579.212)",
    fill: "#B8B896"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 0.621571,
    ry: 0.407019,
    transform: "matrix(-0.432232 -0.901762 0.934266 -0.356577 581.751 579.169)",
    fill: "#B8B896"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.02231,
    ry: 0.812177,
    transform: "matrix(-0.0608497 -0.998147 0.999216 -0.0395933 593.562 580.286)",
    fill: "#B8B896"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M586.023 587.408C585.824 586.96 585.291 586.736 584.832 586.908C584.372 587.08 584.161 587.583 584.36 588.031L584.897 589.242C585.641 589.254 586.058 589.233 586.802 589.167L586.023 587.408Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.679 563.893C594.679 566.813 592.069 569.18 588.85 569.18C585.631 569.18 584.155 566.813 584.155 563.893C584.155 560.973 585.631 558.606 588.85 558.606C592.069 558.606 594.679 560.973 594.679 563.893Z",
    fill: "#EAECE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.267 566.268C581.601 568.022 580.412 569.673 578.612 569.955C576.812 570.237 575.715 568.944 575.381 567.19C575.047 565.435 576.097 565.979 577.897 565.697C579.698 565.415 580.933 564.514 581.267 566.268Z",
    fill: "#EAECE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.23 678.012H574.199C579.042 675.002 587.312 673.116 591.408 672.596C595.504 672.076 597.76 673.026 599.23 678.012Z",
    fill: "#112E3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653 671.386L633.22 681.236C634.17 676.485 640.175 673.591 642.448 671.076C644.721 668.561 648.432 668.447 653 671.386Z",
    fill: "#112E3C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M576.596 554.673C580.611 561.703 585.298 562.775 596.497 561.346C596.342 567.577 596.257 571.063 596.497 575.369C596.906 583.136 595.951 584.919 594.679 589.037H605.203C605.203 589.037 603.338 562.681 599.606 556.675C595.875 550.67 588.723 547 581.26 547C577.637 547 574.528 548.415 572.287 550.482L576.596 554.673Z",
    fill: "#8E452E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 893,
    y: 297,
    width: 27,
    height: 66,
    rx: 8,
    fill: "#281F1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_400_2",
    x1: 720,
    y1: 0,
    x2: 720,
    y2: 1024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4CEE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_400_2",
    x1: 907,
    y1: 360,
    x2: 907,
    y2: 737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#281F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#334D59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_400_2",
    x1: 1195.5,
    y1: 255,
    x2: 1195.5,
    y2: 737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#281F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#334C58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_400_2",
    x1: 444,
    y1: 288,
    x2: 444,
    y2: 702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#281F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#324853"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_400_2",
    x1: 197,
    y1: 225,
    x2: 197,
    y2: 737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#281F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#345361"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_400_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroBackground);
export default __webpack_public_path__ + "static/media/intro_background.becf4383462d50b6a9ba3ebe2d852336.svg";
export { ForwardRef as ReactComponent };